import { useMemo, useRef } from "react"

const INTERACTIVE_ELEMENTS_SELECTOR =
  "a, button, input, select, textarea, label, [role='button'], [data-no-drag-scroll='true']"

export default function useHorizontalDragScroll() {
  const dragStateRef = useRef({
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    pointerId: null,
  })

  return useMemo(
    () => ({
      onPointerDown: (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) {
          return
        }

        if (event.target.closest(INTERACTIVE_ELEMENTS_SELECTOR)) {
          return
        }

        const container = event.currentTarget

        dragStateRef.current = {
          isDragging: true,
          startX: event.clientX,
          scrollLeft: container.scrollLeft,
          pointerId: event.pointerId,
        }

        container.style.cursor = "grabbing"
        container.style.userSelect = "none"
        container.setPointerCapture?.(event.pointerId)
      },
      onPointerMove: (event) => {
        if (!dragStateRef.current.isDragging) {
          return
        }

        const container = event.currentTarget
        const deltaX = event.clientX - dragStateRef.current.startX

        container.scrollLeft = dragStateRef.current.scrollLeft - deltaX
        event.preventDefault()
      },
      onPointerUp: (event) => {
        const container = event.currentTarget

        if (!dragStateRef.current.isDragging) {
          return
        }

        if (
          dragStateRef.current.pointerId !== null &&
          container.hasPointerCapture?.(dragStateRef.current.pointerId)
        ) {
          container.releasePointerCapture?.(dragStateRef.current.pointerId)
        }

        dragStateRef.current.isDragging = false
        dragStateRef.current.pointerId = null
        container.style.cursor = "grab"
        container.style.userSelect = ""
      },
      onPointerCancel: (event) => {
        const container = event.currentTarget

        dragStateRef.current.isDragging = false
        dragStateRef.current.pointerId = null
        container.style.cursor = "grab"
        container.style.userSelect = ""
      },
      style: {
        cursor: "grab",
        touchAction: "pan-y",
      },
    }),
    [],
  )
}
